<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader class="p-1">
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                                <strong>{{ $t('modules.help') }}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">


<!--                                <CButton v-if="status_form==0" class="mr-1 ml-1" @click="insert_data()" type="submit"-->
<!--                                         size="sm" color="secondary">-->
<!--                                    {{ $t('buttons.submit') }}-->
<!--                                </CButton>-->

<!--                                <CButton-->
<!--                                        class="mr-1"-->
<!--                                        size="sm"-->
<!--                                        color="secondary"-->
<!--                                >{{ $t("buttons.cancel") }}-->
<!--                                </CButton>-->

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>

                                    <CTabs>
                                      <CTab  :title="$t('modules.help')">
                                          <CRow>
                                              <CCol col="4">
                                                  <CRow v-for="(item,index) in 9">
                                                      <CCol col="12">
                                                          <CButton v-if="index==active_button" style="border-radius: 0rem"
                                                                   color="primary">Item {{item}}
                                                          </CButton>
                                                          <CButton v-else color="dark" style="border-radius: 0rem"
                                                                   @click="active_button = index">Item {{item}}
                                                          </CButton>
                                                      </CCol>
                                                  </CRow>

                                              </CCol>
                                              <CCol>
                                                  <CRow >
                                                      <CCol col="12">
                                                          Item {{active_button+1}}
                                                      </CCol>
                                                  </CRow>
                                              </CCol>
                                          </CRow>


                                      </CTab>
<!--                                      <CTab  :title="$t('modules.homepage')">-->
<!--                                      </CTab>-->
                                      <CTab  :title="$t('modules.question')"></CTab>
<!--                                      <CTab  :title="$t('modules.news')"></CTab>-->
<!--                                      <CTab  :title="$t('modules.aboutPro')"></CTab>-->
                                      <CTab  :title="$t('modules.aboutIBS')"></CTab>
<!--                                      <CTab  :title="$t('modules.version')"></CTab>-->
                                      <CTab  :title="$t('modules.softwareInfo')"></CTab>

                                    </CTabs>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';



    export default {
        name: 'Login',
        data() {
            return {
                active_button: 0,

            }
        }, mounted() {

        }, watch: {

        },
        methods: {

        }
    }

</script>
